import { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@shared/components/card";
import CardsSliderLayout from "./SliderLayout";
import useSwiperProps from "@shared/hooks/useSwiperProps";
import { IHomeDataProductInput } from "types/home";
import { CARD_TAG, CARD_VARIANT } from "@shared/components/card/types";
import { COURSE_TYPE } from "@types";
import { PercentFestivalPropsCard } from "@shared/components/card/constants";

interface Props extends IHomeDataProductInput {
  viewAllLink: string;
}
const CardsSlider: FC<Props> = ({
  title,
  products,
  slug,
  viewAllLink,
}: Props) => {
  const swiperProps = useSwiperProps();
  const swiperId = "swiper-" + new Date().getTime();

  if (products.length < 4) return null;
  return (
    <CardsSliderLayout
      title={title}
      viewAllLink={viewAllLink}
      swiperId={swiperId}
    >
      <Swiper
        id={swiperId}
        navigation={{
          nextEl: `.swiper-button-next-${swiperId}`,
          prevEl: `.swiper-button-prev-${swiperId} `,
        }}
        className={`swiper-${slug} relative sm:px-3 sm:-mx-3`}
        slidesPerView="auto"
        {...swiperProps}
      >
        {products?.map((product, index) => {
          return (
            <SwiperSlide
              key={index}
              className="festivalCard w-fds-180 pt-4 pb-8 "
            >
              <Card
                key={product.id}
                {...product}
                title={product.title_short || product.title}
                slug={product.slug || ""}
                variant={CARD_VARIANT.GRID}
                isBuy={product.is_buy}
                isFavorite={product.is_favorite}
                watchPercent={product.watchTime_Percent || 0}
                type={product.type as COURSE_TYPE}
                tag={product.hasCertificate ? CARD_TAG.CERTIFICATE : undefined}
                sku={product.sku || ""}
                instructor={product.instructors}
                festival={product.festival_new}
                inCart={product.in_cart || false}
                hasCertificate={product.hasCertificate || false}
                {...PercentFestivalPropsCard}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </CardsSliderLayout>
  );
};

export default CardsSlider;
